module.exports = __webpack_public_path__ + "img/landing_page_background@1x.958ffca.jpg";